var map = {
	"./bmr-demon.png": 50387,
	"./bmr-minion.png": 79764,
	"./bmr-outsider.png": 13396,
	"./bmr-townsfolk.png": 94174,
	"./bmr.png": 54085,
	"./custom.png": 35592,
	"./luf.png": 88142,
	"./snv-demon.png": 92867,
	"./snv-minion.png": 43571,
	"./snv-outsider.png": 93429,
	"./snv-townsfolk.png": 21822,
	"./snv.png": 29857,
	"./tb-demon.png": 36737,
	"./tb-minion.png": 70972,
	"./tb-outsider.png": 22338,
	"./tb-townsfolk.png": 79600,
	"./tb.png": 46827
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 83821;